import {userConstants} from '../_constants';

export function novaPostPrintLink(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NOVA_POST_PRINT_LINK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.GET_NOVA_POST_PRINT_LINK_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.GET_NOVA_POST_PRINT_LINK_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
